import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function ElLimonar() {
  return <NeighborhoodPageContent slug="el-limonar" />;
}